const STORE_URL_PATTERN = new RegExp(
  '^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])?)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))' +
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$',
  'i',
)

const stripProtocol = (url) => url.replace(/^https?:\/\//i, '')

export const isValidStoreUrl = (value) => STORE_URL_PATTERN.test(value)

export function trimShopifyUrl(value) {
  const url = String(value ?? '').trim()
  if (url.includes('.myshopify.com')) {
    const bare = stripProtocol(url)
    const host = bare.includes('//') ? bare.split('/')[2] : bare.split('/')[0]
    return host.split(':')[0].split('?')[0]
  }
  return stripProtocol(url).split(':')[0].split('?')[0].split('/').slice(0, 3).join('/')
}
